/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExchangeV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor" fillRule="evenodd">
      <path d="m8 2 .998.999L9 3v.001l4.707 4.706-1.414 1.414L9 5.829V22H7V5.827L3.707 9.121 2.293 7.707z" />
      <path d="M17 2v16.292L20.293 15l1.414 1.414L16 22.121l-5.707-5.707L11.707 15 15 18.292V2z" />
    </g>
  </Icon>
);
export { SvgExchangeV as ExchangeV };
